import { Camera, Sun, Ruler, Frame, User, Repeat } from "lucide-react";

const VIEWS = [
  { key: "frontal", title: "Frontal", tip: "De frente para a câmara, braços relaxados ao lado do corpo, olhar em frente." },
  { key: "lateral", title: "Lateral", tip: "De lado (lado direito virado para a câmara), braços ao lado do corpo, sem rodar o tronco." },
  { key: "posterior", title: "Posterior", tip: "De costas para a câmara, braços relaxados, cabelo apanhado acima do pescoço." },
];
const RULES = [
  { icon: Ruler, title: "Distância e altura", text: "Câmara a 2,5–3 m, à altura da cintura, na vertical e sem inclinar." },
  { icon: Frame, title: "Enquadramento", text: "Corpo inteiro visível, da cabeça aos pés, com margem acima e abaixo." },
  { icon: Sun, title: "Iluminação e fundo", text: "Luz uniforme de frente, sem contraluz. Fundo liso e claro, sem objetos." },
  { icon: User, title: "Posição e vestuário", text: "Descalço, pés afastados à largura da anca. Roupa justa (ex.: calções e top)." },
  { icon: Repeat, title: "Repetir as condições", text: "Nas avaliações seguintes, mesmo local, distância, altura da câmara e marca no chão." },
];

// Lista compacta para o percurso de captação (reutiliza as mesmas regras do guia).
export function PhotoChecklist() {
  return (
    <ul className="grid gap-2 sm:grid-cols-2 lg:grid-cols-5" data-testid="photo-checklist">
      {RULES.map(({ icon: Icon, title, text }) => (
        <li key={title} className="flex gap-2 rounded-xl border border-slate-800 bg-slate-900/40 p-3">
          <Icon className="w-4 h-4 text-sky-400 shrink-0 mt-0.5" />
          <div><div className="text-xs text-slate-100">{title}</div><p className="text-[11px] text-slate-400 mt-0.5 leading-snug">{text}</p></div>
        </li>
      ))}
    </ul>
  );
}

// Silhueta simples para cada vista (ilustrativa).
function Silhouette({ view }) {
  return (
    <svg viewBox="0 0 60 140" className="h-36 mx-auto" aria-hidden="true">
      <line x1="30" y1="0" x2="30" y2="140" stroke="#38bdf8" strokeDasharray="3 3" strokeWidth="0.8" />
      <circle cx={view === "lateral" ? 32 : 30} cy="14" r="9" fill="#cbd5e1" />
      {view === "lateral" ? (
        <path d="M27 24h10l2 40-3 34 2 36h-6l-3-34-2-34z" fill="#cbd5e1" />
      ) : (
        <path d="M18 26h24l4 36-5 2-3-26-1 34 3 66h-7l-3-52-3 52h-7l3-66-1-34-3 26-5-2z" fill="#cbd5e1" />
      )}
      {view === "posterior" && <line x1="30" y1="28" x2="30" y2="64" stroke="#64748b" strokeWidth="1" />}
    </svg>
  );
}

export default function PhotoGuide() {
  return (
    <div className="space-y-6" data-testid="photo-guide">
      <div className="grid gap-3 sm:grid-cols-3">
        {VIEWS.map((v) => (
          <div key={v.key} className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4 text-center" data-testid={`photo-guide-${v.key}`}>
            <Silhouette view={v.key} />
            <div className="font-display text-slate-50 mt-3">{v.title}</div>
            <p className="text-xs text-slate-400 mt-1">{v.tip}</p>
          </div>
        ))}
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {RULES.map(({ icon: Icon, title, text }) => (
          <div key={title} className="flex gap-3 rounded-xl border border-slate-800 p-4">
            <Icon className="w-5 h-5 text-sky-400 shrink-0" />
            <div><div className="text-sm text-slate-100">{title}</div><p className="text-xs text-slate-400 mt-1">{text}</p></div>
          </div>
        ))}
      </div>
      <div className="flex gap-2 text-xs text-slate-500">
        <Camera className="w-4 h-4 shrink-0" />
        Peça ajuda a outra pessoa ou use um suporte/temporizador. Use sempre o mesmo local e posição em avaliações futuras.
      </div>
    </div>
  );
}
